import { loadStripe } from '@stripe/stripe-js';

// Stripe's objects are kept in these closure variables, NOT on the returned
// component. Alpine wraps the component in a deep reactive proxy, and Stripe
// refuses a proxied Elements object ("elements should have a mounted Payment
// Element"). Handing Stripe the originals is what makes the form submit.
export default function checkout(clientSecret) {
  let stripe = null;
  let elements = null;

  return {
    hasError: false,
    loading: true,
    async init() {
      try {
        // eslint-disable-next-line
        stripe = await loadStripe(process.env.STRIPE_PUBLIC_KEY);
        elements = stripe.elements({ clientSecret });
        elements.create('payment').mount('#checkoutElement');
        this.loading = false;
      } catch (e) {
        // Say what went wrong: a silent failure here cost an afternoon on staging.
        // eslint-disable-next-line no-console
        console.error('Payment form failed to start', e);
        this.hasError = true;
        this.loading = false;
      }
    },
    async completePurchase() {
      if (!stripe || !elements) { this.hasError = true; return; }
      this.loading = true;
      this.hasError = false;

      const baseURL = window.location.origin;

      try {
        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: `${baseURL}/trainer/licenses`,
          },
        });
        if (error) this.hasError = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Payment could not be submitted', e);
        this.hasError = true;
      } finally {
        this.loading = false;
      }
    },
  };
}
